<template>
  <div class="workdate">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div ref="fresh" :style="{height:freshHeight +'px','overflow-y':'scroll','box-sizing': 'border-box','padding-bottom':'80px'}">
        <van-cell
          v-for="info in workInfos"
          :key="info.user_code"
          :title="workdateChange(info.work_date)"
          :label="worktimeChange(info.work_datetime_s,info.work_datetime_e,info.over_times)"
          :label-class="valueClassSet(info.over_times)"
        >
          <div slot="extra">
            <div style="float: right;">{{ workstatusChange(info.work_status) }}</div> <br>
            <div v-if="info.user_name !== null" style="float: right;">{{ '(' + info.user_name + ')' }}</div>
            <div v-if="info.approval === '1'" style="float: right; color: #D89A4B;">{{ approvalStatusChange(info.approval) }}</div>
            <div v-if="info.approval === '2'" style="float: right; color: #69BA6D;">{{ approvalStatusChange(info.approval) }}</div>
            <div v-if="info.approval === '9'" style="float: right; color: #FF0000;">{{ approvalStatusChange(info.approval) }}</div>
          </div>
        </van-cell>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import request from '@/utils/request'
const moment = require('moment')
const approvals = { '1': '未审批', '2': '已审批', '9': '拒绝' }
export default {
  name: 'WorkDate',
  props: { status: { type: String, default: () => { return '0' } }},
  data() {
    return {
      isLoading: false,
      workInfos: [],
      freshHeight: '100%'
    }
  },
  created: function() {
    this.onRefresh()
  },
  mounted() {
    this.freshHeight = document.documentElement.clientHeight - this.$refs.fresh.getBoundingClientRect().top
  },
  methods: {
    workdateChange(val) {
      const week = ' (' + moment(val).locale('zh-cn').format('dd') + ')'
      return val + week
    },
    worktimeChange(dtStart, dtEnd, times) {
      if (dtStart === '' || dtEnd === '') return '　'
      const ts = times.toFixed(2)
      let rs = moment(dtStart).format('HH:mm') + '-' + moment(dtEnd).format('HH:mm')
      if (ts !== '0.00') { rs = rs + ' (' + ts + ')' }
      return rs
    },
    approvalStatusChange(info) {
      if (info === null) {
        return ''
      } else {
        return approvals[info]
      }
    },
    workstatusChange(val) {
      const status = this.GLOBAL.BASE_LEAVE_STATUS
      const work_status = val.split(' / ')
      let rs = ''
      work_status.forEach(function(key) { rs = rs + ' / ' + status[key] })
      return rs.substring(3)
    },
    valueClassSet(val) {
      if (val < 0) {
        return 'text-danger'
      } else if (val > 0) {
        return 'text-primary'
      }
    },
    onRefresh() {
      const self = this
      const params = this.$parent.params
      self.workInfos = []
      request({ url: '/O00/WorkInfos', params: params })
        .then(function(response) {
          self.isLoading = false
          if (response.code === 0) {
            switch (self.status) {
              case '2':
                self.workInfos = response.data.filter(v => v.work_status.indexOf('20') > -1 || v.work_status.indexOf('21') > -1 || v.work_status.indexOf('22') > -1)
                break
              case '3':
                self.workInfos = response.data.filter(v => v.work_status.indexOf('30') > -1 || v.approval === '9' || v.approval === '2' || v.approval === '1')
                break
              default:
                self.workInfos = response.data
                self.$parent.pageData = response.data
                break
            }
          }
        })
        .catch(function(error) {
          self.isLoading = false
          self.$toast.fail(error)
        })
    }
  }
}
</script>

<style slot-scope>
.text-primary {
  color: blue !important;
}
.text-danger {
  color: red !important;
}
</style>
